import React, { Suspense, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router";
import AuthRouteWrapper from "./AuthRouteWrapper";
import ProtectedRouteWrapper from "./ProtectedRouteWrapper";
import routes from "./routeConfig.js.js";
import MainLayout from "../layout/MainLayout";
import { Spin } from "antd";
import Loader from "../Components/Loader";

const NavigationManager = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.updateRoute = (path) => navigate(path);
    return () => {
      if (window.updateRoute) delete window.updateRoute;
    };
  }, [navigate]);

  return (
    <Routes>
      <Route element={<MainLayout />}>
        {routes
          .filter((route) => route.layout === "MainLayout")
          .map(({ path, component, wrapRoute }) => {
            const WrappedComponent = () => (
              <Suspense
                fallback={
                  <Spin
                    size="large"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  />
                }
              >
                {React.createElement(component)}
              </Suspense>
            );

            switch (wrapRoute) {
              case "AuthRoute":
                return (
                  <Route key={path} element={<AuthRouteWrapper />}>
                    <Route path={path} Component={WrappedComponent} />
                  </Route>
                );
              case "ProtectedRoute":
                return (
                  <Route key={path} element={<ProtectedRouteWrapper />}>
                    <Route path={path} Component={WrappedComponent} />
                  </Route>
                );
              default:
                return (
                  <Route key={path} path={path} Component={WrappedComponent} />
                );
            }
          })}
      </Route>

      {routes
        .filter((route) => route.layout !== "MainLayout")
        .map(({ path, component, wrapRoute }) => {
          const WrappedComponent = () => (
            <Suspense
              fallback={
                <Loader />
              }
            >
              {React.createElement(component)}
            </Suspense>
          );

          switch (wrapRoute) {
            case "AuthRoute":
              return (
                <Route key={path} element={<AuthRouteWrapper />}>
                  <Route path={path} Component={WrappedComponent} />
                </Route>
              );
            case "ProtectedRoute":
              return (
                <Route key={path} element={<ProtectedRouteWrapper />}>
                  <Route path={path} Component={WrappedComponent} />
                </Route>
              );
            default:
              return (
                <Route key={path} path={path} Component={WrappedComponent} />
              );
          }
        })}
    </Routes>
  );
};

export default NavigationManager;
